import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SchoolYearPipe } from './schoolYear.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [SchoolYearPipe],
    providers: [SchoolYearPipe],
    exports: [SchoolYearPipe],
})
export class SchoolYearPipeModule {}
